export const DATA_TEST_ID = 'customers-also-bought-carousel';
export const ANALYTIC_RELATED_PRODUCT_KEY = 'analytic_related_product';
